"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.medicationPlansRepositoryMethods = void 0;
const repository_types_1 = require("./repository.types");
exports.medicationPlansRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    createMedication: {
        callMethod: 'POST',
        endpoint: '/medication/create',
    },
    updateMedication: {
        callMethod: 'POST',
        endpoint: '/medication/update',
    },
    discontinueMedication: {
        callMethod: 'POST',
        endpoint: '/medication/discontinue',
    },
    deleteMedicament: {
        callMethod: 'POST',
        endpoint: '/medicament/delete',
    },
    updateHiddenMedicamentStatus: {
        callMethod: 'POST',
        endpoint: '/medicament/hidden-status/update',
    },
    getIntakeSettings: {
        callMethod: 'GET',
        endpoint: '/intake/settings',
    },
    updateIntakeSettings: {
        callMethod: 'POST',
        endpoint: '/intake/settings/update',
    },
    importInsuranceMedicamentList: {
        callMethod: 'POST',
        endpoint: '/medicament/insurance/import',
    },
    getMedicationPlansByDate: {
        callMethod: 'GET',
        endpoint: '/medication-plans',
    },
    createMedicament: {
        callMethod: 'POST',
        endpoint: '/medicament/create',
    },
    createMedicamentListPDF: {
        callMethod: 'POST',
        endpoint: '/medicament/list/pdf',
    },
    getMedicationsWithSource: {
        callMethod: 'GET',
        endpoint: '/medications-with-source/all',
    },
    getMedicationsWithSourceByRange: {
        callMethod: 'GET',
        endpoint: '/medications-with-source/by-range',
    },
    getMedicationsWithSourceById: {
        callMethod: 'GET',
        endpoint: '/medications-with-source/by-id',
    },
    getMedicationTimeMapping: {
        callMethod: 'GET',
        endpoint: '/medications/time-mapping',
    },
    updateMedicationsTime: {
        callMethod: 'PUT',
        endpoint: '/medication/update-time',
    },
    getPharmaCodesFromMedicaments: {
        callMethod: 'GET',
        endpoint: '/medicament/pharma-codes',
    },
    exportEmediplan: {
        callMethod: 'GET',
        endpoint: '/emediplan/export',
    },
    importEmediplan: {
        callMethod: 'POST',
        endpoint: '/emediplan/import',
    },
    extractEmediplanData: {
        callMethod: 'POST',
        endpoint: '/emediplan/extract',
    },
    checkMedicaments: {
        callMethod: 'GET',
        endpoint: '/medicament/check',
    },
    getAllMedicationPlans: {
        callMethod: 'GET',
        endpoint: '/medication-plans/all',
    },
    updateIntakeItem: {
        callMethod: 'PUT',
        endpoint: '/intake/update-item',
    },
    getIntakeStatusOverview: {
        callMethod: 'GET',
        endpoint: '/intake/status-overview',
    },
    getFirstMedicationFromPlan: {
        callMethod: 'GET',
        endpoint: '/medication-plans/first-medication',
    },
    hasActiveMedications: {
        callMethod: 'GET',
        endpoint: '/medication-plan/has-active-medications',
    },
    createMedicationPlanPDF: {
        callMethod: 'POST',
        endpoint: '/medication-plan/pdf',
    },
    hasMedicaments: {
        callMethod: 'GET',
        endpoint: '/medication-plan/has-medicaments',
    },
});
//# sourceMappingURL=medicationPlans.methods.js.map